import { render, staticRenderFns } from "./distributionRule.vue?vue&type=template&id=47431ae0&scoped=true&"
import script from "./distributionRule.vue?vue&type=script&lang=js&"
export * from "./distributionRule.vue?vue&type=script&lang=js&"
import style0 from "./distributionRule.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./distributionRule.vue?vue&type=style&index=1&id=47431ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47431ae0",
  null
  
)

component.options.__file = "distributionRule.vue"
export default component.exports